import { useEffect, useState } from "react";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import { CarrionCategory3 } from "../CarruselCategorias/CarrionCategory3";
import { Header3 } from "../header/Header3";
import { MenuListAlternativo3 } from "../../componentes/MenuListAlternativoHome/MenuListAlternativo3";
import { apiGet } from '../../utils/api';
import { configShop } from '../../states/configShop';
import Modal from "../Modal/modal";
import useWindowWidth from "../hooks/useMediaQuery";
import AddressAdd from "../Address/AddressAdd";
import { userOrder } from '../../states/userOrder';
import { useParams } from "react-router-dom";
export const MenuLocal = () => {
    const { dataConfig } = configShop();
    const width = useWindowWidth()
    let navigate = useNavigate();
    const [openCategories, setOpenCategories] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [propiedadesCompany, setPropiedadesCompany] = useState([]);
    const [nConfig, setNconfig] = useState({});
    const { dataUser, setDataUser } = userOrder();
    // aqui se guarda el color del boton azul
    const [visibleCart, setVisibleCart] = useState(false);
    const obtenerPrecioProducto = (producto) => {
        var precioTopping = 0;
        if (producto.toppings !== undefined) {
            producto.toppings.map((item) => {
                if (item.topingsSeleccionados !== undefined) {
                    item.topingsSeleccionados.map((topping) => {
                        precioTopping = precioTopping + topping.price;
                    });
                }
            });
        }
        var precioTotal = producto.precio + precioTopping;
        precioTotal = precioTotal * producto.cantidadProducto;
        return precioTotal;
    };
    ///
    const [precioTotal, setPrecioTotal] = useState(0);

    const obtenerProductos = () => {
        const informacionLocalStorage = localStorage.getItem(
            "infoProductoSeleccionado"
        );

        if (
            informacionLocalStorage !== undefined &&
            informacionLocalStorage !== null
        ) {
            let parsedRespuesta = JSON.parse(informacionLocalStorage); // JSON.parse convierte la información de string a un objeto de javascript.
            var products = [];
            var precioTotal = 0;
            parsedRespuesta.map((item) => {
                precioTotal += obtenerPrecioProducto(item);
                products.push(item);
            });
            setPrecioTotal(precioTotal);
            setVisibleCart(true);
        } else {
            setVisibleCart(false);
            // alert("No tienes productos en el carrito!! :(");
        }
    };

    const pleiztUuids = window.location.hostname.split(".")[0];

    var pleiztUuid;
    if (pleiztUuids === undefined) {
        if (localStorage.getItem("pleiztUuid") === undefined) {
        } else {
            pleiztUuid = localStorage.getItem("pleiztUuid");
        }
    } else {
        pleiztUuid = pleiztUuids;
        if (localStorage.getItem("pleiztUuid") !== pleiztUuid) {
            localStorage.clear();
        }
        localStorage.setItem("pleiztUuid", pleiztUuid);
    }
    const urlHome = '';
    const codigoPais = "es-CO";
    const codigoCurrency = "COP";
    useEffect(() => {
        localStorage.setItem("typeSend", 2);
        setDataUser({ deliveryMethod: 2 });
        (async function () {
            const res = await apiGet('/home-local');
            var mensajeExito = res.success;
            if (mensajeExito === "success") {
                setOpenCategories(res.data.categories); // aqui estoy pasando el objeto categories, no es necesario pasarlo en el map.
                setPropiedadesCompany(res.properties);
                setNconfig(res.data.config)
            } else {
                console.log("No hay menus para este restaurante");
            }
        })();
        obtenerProductos();
    }, [dataUser.shopData]);

    //
    const [search, setSearch] = useState("");
    const filteredProducts = openCategories?.map(category => ({
        ...category,
        items: category.items.filter(item =>
            item.name.toLowerCase().includes(search.toLowerCase()) ||
            item.description.toLowerCase().includes(search.toLowerCase())
        )
    }))
        .filter(category => category.items.length > 0); // eliminamos categorías vacías


    return (
        <div className="App container justify-content-center align-items-center">
            <header className="App-header" >
                <Header3 propiedadesCompany={propiedadesCompany} configHeader={nConfig} />
            </header>

            <CarrionCategory3
                openCategories={openCategories}
                setSearch={setSearch}
                search={search}
            />
            {filteredProducts?.map((item, i) => {
                return (
                    <section id={item.uuid} className="menu-3-section color-text" style={{ "--btn-font-color": dataConfig?.color_font }}>
                        <h2 className="h4">{item.name}</h2>
                        <MenuListAlternativo3
                            categoriaSeleccionada={item.items}
                            codigoCurrency={codigoCurrency}
                            codigoPais={codigoPais}
                            productoFiltrado={null}
                        />
                    </section>
                )
            })}
            {visibleCart && (
                <div style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    background: "#FFFFFF",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
                    padding: "12px 16px",
                    zIndex: 1000
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>Subtotal</p>
                            <h3 style={{ fontSize: "18px", margin: 0, color: "#000" }}>
                                {precioTotal.toLocaleString(codigoPais, {
                                    style: "currency",
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                    currency: codigoCurrency,
                                })}
                            </h3>
                        </div>
                        <button
                            onClick={() => navigate("/shoppingCart/")}
                            className="boton-home-v2" style={{ "--btn-color": dataConfig?.color_botton, "--btn-text-color": dataConfig?.color_button_text }}>
                            <p className="boton-title-v2"> Ver carrito</p>
                        </button>
                    </div>
                </div>
            )}
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openModal}
                title={"Datos de entrega."}
            >
                <AddressAdd
                    setOpenModal={setOpenModal}
                />
            </Modal>
        </div>

    );
};
export default MenuLocal;
